import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';
import {Batiment} from '../Models/Batiment';
import {cloneDeep} from "lodash";
import * as _ from 'lodash';
import {ROUTES_PATHS} from "../const/routes";
import {specialRenovationTypesNrj} from "../const/utils";

@Component({
	selector: 'app-modal-reglages',
	templateUrl: './modal-reglages.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./modal-reglages.component.less']
})
export class ModalReglagesComponent implements OnInit {
	globalTxt: any;
	modalsTxt: any;
	prestations: any = [];
	//pieces: any = [];
	isPathEstimationRapide: boolean = false;
	batiment: Batiment = JSON.parse(localStorage.getItem("BATIMENT")!);
	batSimId: any;
	arrSimDetail: any;
	renovation: any = localStorage.getItem("RENOVATION");

	constructor(
		public app: AppComponent,
		//private piecesComp: PiecesComponent,
	) {
	}

	ngOnInit(): void {
		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		this.isPathEstimationRapide = (this.app.router.url == '/' + ROUTES_PATHS.ESTIMATION_RAPIDE) ? true : false;

		this.getInfosInit();
	}

	getInfosInit() {
		// Get global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;

			// Get the modal texts
			this.app.dataInitService.getModalTextsForModalComponentOnce(modalsTxt => {
				this.modalsTxt = modalsTxt.reglages;

				let batSimId: any = (this.batiment) ? this.batiment.simulationId : null;
				this.batSimId = +batSimId;
				console.log("this.batSimId ==> ", this.batSimId);
				if (this.batSimId) this.getSimulationParamsById(this.batSimId);
			})
		});
	}


	onChangePicSelected(_piece: any) {
		console.log("_piece ==> ", _piece);
		//if (!this.isPathEstimationRapide) return;
		_piece.arrPrestations.forEach((presta: any) => {
			if (presta.isDisabled) return;
			presta.isSelected = _piece.isSelected;
			if (_piece.type != 12) if (presta.id == 6) presta.isSelected = false;
		})
	}

	onChangeAllPrestaSelected(_presta: any, _selected: any) {
		console.log("_presta _selected ==>", _selected);
		if (_presta.SCA_ID != 99) {
			this.arrSimDetail.forEach((pic: any) => {
				console.log("pic ==>", pic);
				pic.arrPrestations.forEach((presta: any) => {
					if (presta.id === _presta.SCA_ID) {
						if (presta.isDisabled) return;
						presta.isSelected = _selected;
						if (presta.id == 6 && pic.type != 12) presta.isSelected = false;
					}
				})
			})
		}
	}

	onValidateReglages() {
		// ==> Sauvegarder la simulation
		console.log("this.arrSimDetail:", this.arrSimDetail);
		this.setSimulationParamsById(this.batSimId, this.arrSimDetail);
	}

	getClassSwitchCentralNrj(_presta: any, _piece: any) {
		let classSwitch = '';
		if (_presta.id == 4 && _piece.type == -1 && (specialRenovationTypesNrj.includes(this.renovation))) {
			classSwitch = 'switch-central-nrj';
		}
		return classSwitch;
	}

	getSimulationParamsById(_sinId: number) {
		//let result: any = [];
		this.app.apiToolsService.getSimulationParamsById(_sinId).subscribe(res => {
			//console.log("res getSimulationParamsById", res);

			let arrSimDetailTemp: any = cloneDeep(res);
			let arrSimDetail: any = JSON.parse(arrSimDetailTemp);

			let central = arrSimDetail.filter((pic: any) => {
				return pic.type == -1;
			})[0];
			console.log("central ==> ", central);

			if (central) {
				for (var i = 0; i < central.arrPrestations.length; i++) {
					if (central.arrPrestations[i].id != 2 && central.arrPrestations[i].id != 4) {
						central.arrPrestations[i].isSelected = false;
						central.arrPrestations[i].isDisabled = true;
					}
				}
			}

			//si pas cuisine, décocher aménagement
			let notCuisine = arrSimDetail.filter((pic: any) => {
				return pic.type != 12;
			});
			//console.log("notCuisine ==> ", notCuisine);

			if (notCuisine.length > 0) {
				notCuisine.forEach((pic: any) => {
					// let arrPrestationsOrdered = _.orderBy(pic.arrPrestations, ['id']);
					// console.log("arrPrestationsOrdered ==> ", pic.label, arrPrestationsOrdered);
					// pic.arrPrestations = arrPrestationsOrdered;

					let amenagement = pic.arrPrestations.filter((presta: any) => {
						return presta.id == 6;
					})[0];

					if (amenagement && amenagement.isSelected) amenagement.isSelected = false;
					//console.log("amenagement ==> ", amenagement);
				});
			}

			//si pas piece d'eau, décocher plomberie
			/*let notPicEau = arrSimDetail.filter((pic: any) => {
				return pic.type != 12 && pic.type != 36 && pic.type != 28;
			});
			console.log("notPicEau ==> ", notPicEau);

			if (notPicEau.length > 0) {
				notPicEau.forEach((pic: any) => {
					for (var i = 0; i < pic.arrPrestations.length; i++) {
						if (pic.arrPrestations[i].isSelected && pic.arrPrestations[i].id == 3) pic.arrPrestations[i].isSelected = false;
					}
				});
			}*/

			arrSimDetail.forEach((pic: any) => {
				let total = _.filter(arrSimDetail, function (obj) {
					return obj.type == pic.type;
				}).length;
				pic.picNum = (total > 1) ? pic.picNum : '';

				let arrPrestationsOrdered = _.orderBy(pic.arrPrestations, ['id']);
				//console.log("arrPrestationsOrdered ==> ", pic.label, arrPrestationsOrdered);
				pic.arrPrestations = arrPrestationsOrdered;

				let chauffage = pic.arrPrestations.filter((presta: any) => {
					return presta.picto == 'presta_chauffage';
				})[0];
				//console.log("chauffage ==> ", chauffage);
				if (chauffage && (specialRenovationTypesNrj.includes(this.renovation))) {
					chauffage.label = chauffage.label + ' ' + this.modalsTxt.labelChauffageAutre;
				}
			});

			this.arrSimDetail = cloneDeep(arrSimDetail);

			//Récupération des prestations et affectation du statut
			let modalData = JSON.parse(localStorage.getItem('modalOpen')!);
			this.prestations = (modalData) ? modalData.data : [];
			console.log(this.prestations);

			this.prestations.forEach((item: any) => {
				if (!item.SCA_ID) item.SCA_ID = item.id;
				if (item.SCA_ID != 99) item.isSelectedAll = this.getSelectedAll(item.SCA_ID);
			});

			console.log("this.arrSimDetail ==> ", this.arrSimDetail);
			console.log("this.prestations ==> ", this.prestations);
		});
	}

	/*getSelectedAll(prestaId: any) {
		// console.log(prestaId);
		let AllSelected = false;
		this.arrSimDetail.forEach((piece: any) => {
			let prestationsSelected: any = piece.arrPrestations.filter((prest: any) => {
				return prest.id == prestaId;
			})[0];

			if (piece.type == 12) {
				//console.log("cuisine ==>", prestationsSelected, prestationsSelected.id == 6 && prestationsSelected.isSelected);
				AllSelected = (prestationsSelected.id == 6 && prestationsSelected.isSelected);
			} else {
				AllSelected += prestationsSelected.isSelected;
			}

		})
		//console.log(AllSelected);
		return AllSelected;
	}*/
	getSelectedAll(prestaId: any): boolean {
		//Cocher si au moins une pièce a la prestation sélectionnée
		return this.arrSimDetail.some((piece: any) =>
			piece.arrPrestations.some( (presta: any) =>
				presta.id == prestaId && presta.isSelected
			)
		);
	}

	// getSelectedAllPresta(prestaId: any){
	//   console.log(prestaId);
	//   let AllSelected = false;
	//   this.arrSimDetail.forEach((piece: any) =>{
	//   let prestationsSelected = piece.arrPrestations.filter((prest: any)=>{
	//     return prest.id == prestaId;
	//   })[0];

	//   console.log(prestationsSelected);
	//   AllSelected += prestationsSelected.isSelected;
	//   console.log(AllSelected);


	//   })
	//     return AllSelected;
	// }

	setSimulationParamsById(_sinId: number, _list: any) {
		console.log("_sinId ==> ", _sinId);
		console.log("_list ==> ", _list);

		this.app.apiToolsService.setSimulationParamsById(_sinId, _list).subscribe(res => {
			console.log("res ==> ", res);

			if (res == 'OK') {
				location.reload();
			}
		});
	}
}
